"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _package = { version: '3.26.7' };

var _default = _package.version;
exports["default"] = _default;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/version/index.js
// module id = 1075
// module chunks = 0